import { useEffect, useState, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  Card,
  CardHeader,
  Alert,
  Table,
  Spinner,
  CustomInput
} from 'reactstrap'

import {
  getNotificationSettingAction,
  notificationSettingUpdateAction,
  notificationSettingUpdateResetAction
} from "./store/actions"

const NotificationSetting = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [successMsg, setSuccessMsg] = useState(false)
  const [successMsgTxt, setSuccessMsgTxt] = useState("")

  const [updateStatusChildUserRes, setUpdateStatusChildUserRes] = useState(null)
  const [showMsgWhenDelete, setShowMsgWhenDelete] = useState(false)
  const [showMsgWhenUpdateStatus, setShowMsgWhenUpdateStatus] = useState(false)

  const {getNotificationSettingLoading, getNotificationSettingData, getNotificationSettingError} = useSelector(store => store.getNotificationSettingReducer)
  const {notificationSettingUpdateLoading, notificationSettingUpdateData, notificationSettingUpdateError} = useSelector(store => store.notificationSettingUpdateReducer)

  useEffect(() => {
    if (notificationSettingUpdateData?.status) {
      setSuccessMsg(true)
      setSuccessMsgTxt(notificationSettingUpdateData?.msg)
      dispatch(notificationSettingUpdateResetAction())
      setTimeout(() => { setSuccessMsg(false) }, 2500)
    }
  }, [notificationSettingUpdateData])

  useEffect(() => {
    dispatch(getNotificationSettingAction())
  }, [])

  const handleStatus = (settingId) => {
    setSuccessMsg(false)
    dispatch(notificationSettingUpdateAction({
      id: settingId
    }))
  }

  return (
    <Fragment>
      <Card>
        <CardHeader className="text-center">
          <h2 className="text-primary">Email Notification Setting</h2>
        </CardHeader>
        <div className="px-2">
          <Alert color="success" isOpen={successMsg} toggle={() => setSuccessMsg(false)}>
            <div className='alert-body'>
              {successMsgTxt}
            </div>
          </Alert>
          <Alert color={!updateStatusChildUserRes?.status ? 'danger' : 'success'} isOpen={showMsgWhenUpdateStatus} toggle={() => setVisible(false)}>
            <div className='alert-body'>
              {updateStatusChildUserRes?.msg}
            </div>
          </Alert>
        </div>
        <Table responsive>
          <thead>
            <tr>
              <th>Sr.</th>
              <th>Notification Type</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
          {getNotificationSettingLoading ? (<tr><td colSpan={3} align="center"><Spinner color="primary" /></td></tr>) : (
              getNotificationSettingData?.data?.map((mapData, index) => (
                  <tr key={index}>
                    <td><span className='align-middle font-weight-bold'>{index + 1}</span></td>
                    <td>{mapData.title}</td>
                    <td>
                      <CustomInput
                          className='custom-control-success'
                          type='switch'
                          id={`status-${index}`}
                          name='success'
                          inline
                          defaultChecked={mapData.status === 1}
                          onChange={() => handleStatus(mapData.id)}
                          disabled={notificationSettingUpdateLoading}
                      />
                    </td>
                  </tr>
              ))
          )}
          </tbody>
        </Table>
      </Card>
    </Fragment>
  )
}
export default NotificationSetting
